module.exports = __webpack_public_path__ + "media/images/noaa-50th-logo-463cc13792af4ace1aa2ecb5f72e227c.png";